export const tailwindConfig = {
  fontFamily: {
    sans: ['Inter', 'Kohinoor Devanagari', 'Noto Sans Devanagari', 'Rubik', 'sans-serif'],
    serif: ['"Source Serif 4"', 'Georgia', 'serif'],
  },
  extend: {
    colors: {
      hpclBlue: {
        50: '#eaf0fa',
        100: '#d5e1f5',
        200: '#abc3ec',
        300: '#6d96dd',
        400: '#2f69cf',
        500: '#1e4384',
        600: '#193a72',
        700: '#143160',
        800: '#0f274e',
        900: '#0b1f3f',
        950: '#071733',
      },
      hpclRed: {
        50: '#ffeceb',
        100: '#ffd3cf',
        200: '#ffa99f',
        300: '#ff7b6f',
        400: '#f54b3f',
        500: '#eb2d22',
        600: '#d1231a',
        700: '#a51c15',
        800: '#79140f',
        900: '#5a100c',
        950: '#3f0b08',
      },
      hpSea: {
        50: '#e6f7fa',
        100: '#c7eef3',
        200: '#8fdbe6',
        300: '#55c6d5',
        400: '#2aaec0',
        500: '#26a2b0',
        600: '#1f8290',
        700: '#186670',
        800: '#114a51',
        900: '#0b3238',
        950: '#051f24',
      },
      hpBrass: {
        50: '#f7f6ea',
        100: '#edebd3',
        200: '#d9d4a5',
        300: '#c1ba73',
        400: '#aa9f4f',
        500: '#a19a3d',
        600: '#887f33',
        700: '#6e652a',
        800: '#534b20',
        900: '#393217',
        950: '#221d0e',
      },
      hpMarigold: {
        50: '#fff6e8',
        100: '#fee9c5',
        200: '#fdcf8c',
        300: '#fcb554',
        400: '#fa9e28',
        500: '#f49e1d',
        600: '#d88516',
        700: '#b26a11',
        800: '#8c4f0c',
        900: '#6a3b08',
        950: '#4a2805',
      },
      leftArrow: '#111111',
    },
    borderRadius: {
      xl: '1rem',
    },
    boxShadow: {
      hpcl: '0 8px 24px rgba(30, 67, 132, 0.18)',
    },
  },
};
